import {ExpenseReportDao} from '../../dao';
import {
    ErrorModel
} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'DOWNLOAD_EXPENSE_REPORT';

export async function downloadExpenseReport(
    userData: Record<string, string>,
    expenseReportId: number
) {
    try {
        const result = await ExpenseReportDao.downloadExpenseReport(userData.userToken, expenseReportId);

        return result;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors du téléchargement d\'une note de frais',
            error: error
        });
    }
}
